
        import 'Header.082988a.css-module'
        export default {"Header":"Header_Header_082988a","Logo":"Logo_Header_082988a","signOut":"signOut_Header_082988a"}
    